module.exports = __webpack_public_path__ + "img/favicon.24bda47a.jpeg";